import filter from './lkFilter';
import crypto from 'crypto-js';
import moment from 'moment';
import localStorage from 'localStorage';
// import { get } from 'core-js/fn/dict';
export const isArray = (o) => {
  return o && typeof o == 'object' && o.constructor == Array;
};

export const localSave = (key, item) => {
  try {
    localStorage.setItem(key, item);
  } catch (e) {
    console.log(e);
  }
};

export const localRead = (key) => {
  return localStorage.getItem(key) || '';
};

// 补齐
export const preZeroFill = (num, size) => {
  if (num >= Math.pow(10, size)) {
    //如果num本身位数不小于size位
    return num.toString();
  } else {
    var _str = Array(size + 1).join('0') + num;
    return _str.slice(_str.length - size);
  }
};

//替换所有换行符
export const convertEnter = (content) => {
  let stringStr = content;
  try {
    stringStr = stringStr.replace(/\r\n/g, '<BR>');
    stringStr = stringStr.replace(/\n/g, '<BR>');
  } catch (e) {
    // alert(e.message);
  }
  return stringStr;
};
export const checkIDNumber = (IDNumber) => {
  if (
    IDNumber == null ||
    IDNumber.trim().length == 0 ||
    IDNumber.trim().length != 18
  ) {
    return false;
  }
  let wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  let c = ['1', '0', 'x', '9', '8', '7', '6', '5', '4', '3', '2'];
  let sum = 0;
  let numbers = IDNumber.trim().split('');
  for (let i = 0; i < 17; i++) {
    sum = sum + parseInt(numbers[i]) * wi[i];
  }

  let mod = sum % 11;
  let vertifyCode = c[mod].toLowerCase();
  let lastCode = numbers[17].toLowerCase();
  return vertifyCode == lastCode;
};
export const IDNumberFilter = (id_type, id_number) => {
  return id_type == 'A' ? filter.starEx(id_number, 10, 4, 4) : id_number;
};
export const UUID = () => {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
    c,
  ) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x7) | 0x8).toString(16);
  });
  return uuid;
};
export const convertDateFromString = (dateStr) => {
  let str = dateStr.replace(new RegExp('-', 'gm'), '/');
  return new Date(str);
};
export const base64 = (target) => {
  if (typeof target !== 'string') {
    return target;
  }
  let utf = crypto.enc.Utf8.parse(target);
  let base64 = crypto.enc.Base64.stringify(utf);
  return base64;
};

export const deBase64 = (target) => {
  if (typeof target !== 'string') {
    return target;
  }
  var utf = crypto.enc.Base64.parse(target);
  var str = crypto.enc.Utf8.stringify(utf);
  return str;
};
export const encryptByDES = (message) => {
  var keyHex = crypto.enc.Hex.parse(
    '094A54CB6CD530C595A67A0C9066789CD086E0D9E2A4A351',
  );
  var iv = crypto.enc.Hex.parse('0102030405060708');
  var getMessage = message + '\x08'.repeat(8 - (message.length % 8));
  var encrypted = crypto.TripleDES.encrypt(getMessage, keyHex, {
    iv: iv,
    mode: crypto.mode.CBC,
    padding: crypto.pad.NoPadding,
  });
  /*return encrypted.toString();*/
  return crypto.enc.Base64.stringify(encrypted.ciphertext);
};
export const decryptByDES = (str) => {
  var crypto_key = crypto.enc.Utf8.parse('cf410f8f9a4a42cc7a7f48fc4134e8f9');
  var decrypt_str = crypto.TripleDES.decrypt(str, crypto_key, {
    mode: crypto.mode.CBC,
    padding: crypto.pad.Pkcs7,
  });
  return decrypt_str.toString(crypto.enc.Utf8);
};
export const phoneHidden = (target) => {
  let targetStr = JSON.stringify(target);
  return targetStr.substring(0, 3) + '****' + targetStr.substring(8, 11);
};
export const regexs = {
  allphone: /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/,
  /*email: /^[0-9a-z][0-9a-z\-\_\.]+@([0-9a-z][0-9a-z\-]*\.)+[a-z]{2,}$/i, //邮箱
  phone: /^0[0-9]{2,3}[2-9][0-9]{6,7}$/, //座机手机号码
  ydphpne: /^((13[4-9])|(15[012789])|147|182|187|188)[0-9]{8}$/, //移动手机号码
  allphpne: /^((13[0-9])|(14[0-9])|(17[0-9])|(15[0-9])|(18[0-9]|(19[0-9])))[0-9]{8}$/, //所有手机号码
  /*ltphpne: /^((13[0-2])|(15[56])|(186)|(145))[0-9]{8}$/, //联通手机号码
  dxphpne: /^((133)|(153)|(180)|(189))[0-9]{8}$/, //电信手机号码
  url: /^http:\/\/([0-9a-z][0-9a-z\-]*\.)+[a-z]{2,}(:\d+)?\/[0-9a-z%\-_\/\.]+/i, //网址
  num: /[^0-9]/, //数字
  cnum: /[^0-9a-zA-Z_.-]/,
  photo: /\.jpg$|\.jpeg$|\.gif$/i, //图片格式
  row: /\n/gi,*/
  passport: /^[a-zA-Z0-9]{5,17}$/, //护照校验规则
  HMPassport: /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/, //港澳通行证校验规则
  TWPassport: /^[0-9]{5,12}$/, //台胞证校验规则
  // TWPassport2: (/^[0-9]{10}$/),                           //台胞证也符合
  /*name: /^[\u4e00-\u9fa5a-zA-Z\\s➋-➒]+$/, //用户姓名校验  汉字 英文 空格*/
};
export const getTicketStatusDesc = (status) => {
  let statusDesc = '';
  switch (status) {
    case 0:
      statusDesc = '已创建';
      break;
    case 1:
      statusDesc = '等待出票';
      break;
    case 2:
      statusDesc = '未使用';
      break;
    case 3:
      statusDesc = '已使用';
      break;
    case 4:
      statusDesc = '已失效';
      break;
    case 5:
      statusDesc = '部分使用';
      break;
    case 6:
      statusDesc = '已锁定';
      break;
    case 7:
      statusDesc = '已退票';
      break;
    case 8:
      statusDesc = '等待退款确认';
      break;
    case 9:
      statusDesc = '已退款';
      break;
    case 10:
      statusDesc = '已购买';
      break;
    case 12:
      statusDesc = '已取消';
      break;
    case 14:
      statusDesc = '出票失败';
      break;
    case 20:
      statusDesc = '已验票';
      break;
    default:
  }
  return statusDesc;
};
export const getOrderStatusDesc = (status) => {
  let statusDesc = '';
  switch (status) {
    case 0:
      statusDesc = '已完成';
      break;
    case 1:
      statusDesc = '未支付';
      break;
    case 2:
      statusDesc = '待出票';
      break;
    case 3:
      statusDesc = '已失效';
      break;
    case 4:
      statusDesc = '已取消';
      break;
    case 5:
      statusDesc = '已关闭';
      break;
    case 6:
      statusDesc = '出票中';
      break;
    case 7:
      statusDesc = '已出票';
      break;
    case 8:
      statusDesc = '出票失败';
      break;
    case 9:
      statusDesc = '待退款';
      break;
    case 10:
      statusDesc = '已退款';
      break;
    case 11:
      statusDesc = '等待支付确认';
      break;
    case 12:
      statusDesc = '待部分退款';
      break;
    case 13:
      statusDesc = '已部分退款';
      break;
    case 14:
      statusDesc = '退款中';
      break;
    case 15:
      statusDesc = '部分退单';
      break;
    case 16:
      statusDesc = '部分出票';
      break;
    default:
  }
  return statusDesc;
};
export const getDayByNow = (dateStr) => {
  //日期时间是否今天或者今天以后
  let m2 = moment();
  let m1 = moment(dateStr);
  let du = moment.duration(m1 - m2, 'ms'); //做差
  let days = du.get('days');
  console.log('天数是', dateStr, days);
  if (days < 0) {
    return false;
  } else {
    return true;
  }
};
export const getImageAllUrl = (str) => {
  if (str.indexOf('https://') != -1) {
    return str;
  } else {
    return process.env.VUE_APP_IMAGE_URL + str;
  }
};
